<div class="modal-header border-0 mx-1 justify-content-start">
    <a href="javascript:void(0);" class="back text-grad" (click)="back()">
        <i class="las la-angle-left"></i>
    </a>
    <h5 class="modal-title fw-bold text-uppercase">Titulares dos ingressos</h5>
</div>
<div class="modal-body pt-sm-0">
    <swiper class="ticket-holders" [config]="config" [autoHeight]="true" (swiper)="onSwiper($event)">
        <ng-template swiperSlide *ngFor="let ticket of order.tickets; let id= index;">
            <div class="row px-1">
                <div class="col-sm-12 mb-3">
                    <h3 class="modal-title fw-bold text-uppercase text-grad">
                        {{ ticket.name }}
                        <div *ngIf="loadingFindUser" class="spinner-grow" style="width: 25px; height: 25px;"
                            role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </h3>
                    <h6 class="text-uppercase fw-bold m-0">{{id+ 1 }}&#186; Ingresso</h6>
                </div>
                <div  class="w-100 mb-5" *ngIf="showSesiTerms == true">
                    <div class="d-flex align-items-center">
                        <input type="checkbox" class="me-3" [checked]="ticket.sesiTermsAccepted" (change)="sesiTermsOfUseChange($event)" /> 
                        {{sesiTerms}}
                    </div>                  
                    <br />
                    <br />
                    <b>Ao avançar declaro que as informações acima são verdadeiras.</b>
                </div>
                <div class="col-sm-6 mb-3">                  
                    <div class="form-floating">
                        <input type="text" (keyup)="findUser(id)" (keydown)="preventTab($event)"
                            [dropSpecialCharacters]="false" class="form-control" placeholder="cpf" mask="000.000.000-00"
                            [formControl]="customers!.get('customer')!['controls'][idx].get('doc')">
                        <label for="cpf">CPF <span *ngIf="loadingFindUser" class="sr-only">...</span></label>
                    </div>
                </div>
                <div class="col-sm-6 mb-3">
                    <div class="form-floating">
                        <input type="text" class="form-control text-capitalize" [id]="'name'+id" placeholder="name"
                            name="name" [formControl]="customers!.get('customer')!['controls'][idx].get('name')">
                        <label for="name">Nome completo</label>
                    </div>
                </div>
                <div class="col-sm-6 mb-3">
                    <div class="form-floating">
                        <input type="email" class="form-control" [id]="'email'+id" placeholder="email" name="email"
                            [formControl]="customers!.get('customer')!['controls'][idx].get('email')">
                        <label for="email">Email</label>
                    </div>
                </div>
                <div class="col-sm-6 mb-3">
                    <div class="form-floating">
                        <input type="tel" class="form-control" [id]="'phone'+id" placeholder="phone" name="phone"
                            mask="(00) 00000-0000"
                            [formControl]="customers!.get('customer')!['controls'][idx].get('phone')">
                        <label for="phone">Telefone</label>
                    </div>
                </div>
            </div>
        </ng-template>
    </swiper>
</div>
<div class="modal-footer border-0 pt-0">
    <button class="btn btn-grad btn-lg" (click)="continue()">Continuar</button>
</div>